import { IAcquisition } from '@models/acquisition';
import { DASH } from './spread/spread-settings';

export const getAcquisitionNamesByIds = (acquisitionIds: number[] | string, acquisitions: IAcquisition[]) => {
  try {
    if (!acquisitionIds || acquisitionIds.length === 0) {
      return DASH;
    }

    acquisitionIds = `${acquisitionIds}`
      .trim()
      .split(',')
      .map(x => parseInt(x, 10)) as number[];

    const names = acquisitionIds
      .map((n: number) => {
        const acq = acquisitions.find(({ AcquisitionId }) => AcquisitionId === n);
        return acq ? acq.AcquisitionName : n.toString();
      })
      .join(', ');

    return names || DASH;
  } catch (err) {
    console.error('Error getting the acquisition names for acquisition ids', acquisitionIds, { acquisitions });
    return DASH;
  }
};
